<template>
    <b-form>
        <b-form-group
            id="input-group-type"
            label="Type*:"
            label-for="input-type"
            label-class="font-weight-bold pt-0"
            label-cols="2"
        >
            <b-form-input
                v-if="!isNew"
                id="input-type"
                :value="order_type_name"
                readonly
            ></b-form-input>
            <b-form-select
                v-else
                id="input-type"
                v-model="orderModel.order_type_id"
                :options="orderTypes | mapOptions"
                required
            >
                <template #first>
                    <b-form-select-option :value="null" disabled
                        >Select Activity Type</b-form-select-option
                    >
                </template>
            </b-form-select>
        </b-form-group>

        <b-form-group
            v-show="!!orderModel.order_type_id"
            id="input-group-category"
            label="Category:"
            label-for="input-category"
            label-class="font-weight-bold pt-0"
            label-cols="2"
        >
            <b-form-input
                v-if="!isNew"
                id="input-category"
                :value="request_category_name"
                readonly
            ></b-form-input>
            <b-form-select
                v-else
                id="input-category"
                v-model="orderModel.request_category_id"
                :options="categories | mapOptions"
                required
            >
                <template #first>
                    setCustom
                    <b-form-select-option :value="null"
                        >Select Category If Applicable</b-form-select-option
                    >
                </template>
            </b-form-select>
        </b-form-group>

        <div v-if="entity == entities.Customer">
            <b-form-row class="mb-3">
                <b-col cols="2">
                    <label class="font-weight-bold">Customer</label>*:
                </b-col>

                <b-col>
                    <b-row no-gutters>
                        <b-col>
                            <customer-type-ahead
                                v-model="orderModel.customer_id"
                                @set-customer="setCustomer"
                                required
                                :disabled="!isNew || isCustomerVisible"
                            ></customer-type-ahead>
                        </b-col>
                        <b-col cols="1" v-if="isNew">
                            <b-button @click="setNewCustomerForm" block>
                                <b-icon icon="plus-circle"></b-icon
                            ></b-button>
                        </b-col>
                    </b-row>

                    <view-customer
                        ref="view-customer-ref"
                        v-if="isCustomerVisible"
                        :id="orderModel.customer_id"
                        :hide-buttons="true"
                        @update-model="setCustomer"
                    />
                </b-col>
            </b-form-row>
            <b-form-row v-if="!isCustomerVisible && isNew" class="mb-3">
                <b-col cols="2">
                    <label class="font-weight-bold">Delivery Location</label>*:
                </b-col>
                <b-col>
                    <portal-target name="deliveryLocationView"></portal-target>
                </b-col>
            </b-form-row>
        </div>

        <b-form-group
            v-if="!!orderModel.order_type_id"
            id="input-group-reference_no"
            label="Reference No:"
            label-for="input-reference_no"
            label-class="font-weight-bold pt-0"
            label-cols="2"
            class="mt-6"
        >
            <b-form-input
                id="input-reference_no"
                v-model="orderModel.reference_no"
                placeholder="Unique Reference No. Leave Blank for Auto Generation.."
                :readonly="!isNew"
            ></b-form-input>
        </b-form-group>

        <b-form-group
            v-show="!!orderModel.order_type_id"
            id="input-group-description"
            label="Description:"
            label-for="input-description"
            label-class="font-weight-bold pt-0"
            label-cols="2"
            class="mt-6"
        >
            <b-form-textarea
                id="input-description"
                v-model="orderModel.description"
                placeholder="Brief description of activity..."
                rows="3"
                max-rows="4"
                :disabled="!editMode"
            ></b-form-textarea>
        </b-form-group>

        <b-form-group
            id="input-group-driver"
            label="Assigned To:"
            label-for="input-driver"
            label-class="font-weight-bold pt-0"
            label-cols="2"
            v-if="!!orderModel.order_type_id && entity != entities.Internal"
        >
            <b-form-input
                v-if="!editMode"
                id="input-driver"
                :value="officer_name"
                readonly
            ></b-form-input>
            <b-form-select
                v-else
                id="input-driver"
                v-model="orderModel.driver_id"
                :options="officers | mapOptions"
                required
            >
                <template #first>
                    <b-form-select-option :value="null" disabled
                        >Select Officer</b-form-select-option
                    >
                </template>
            </b-form-select>
        </b-form-group>

        <b-form-row v-if="!!orderModel.order_type_id && isNew">
            <b-col cols="2">
                <label class="font-weight-bold pt-0">Items:</label>
            </b-col>
            <b-col>
                <b-card>
                    <portal-target name="OrderItemsView"> </portal-target>
                </b-card>
            </b-col>
        </b-form-row>

        <b-form-row v-if="!!orderModel.order_type_id && isNew">
            <b-col cols="2">
                <label class="font-weight-bold pt-0">Messages:</label>
            </b-col>
            <b-col>
                <b-card class="mt-2">
                    <portal-target name="OrderMessagesView"> </portal-target>
                </b-card>
            </b-col>
        </b-form-row>

        <b-form-row v-if="!!orderModel.order_type_id && isNew">
            <b-col cols="2">
                <label class="font-weight-bold pt-0">Attachments:</label>
            </b-col>
            <b-col>
                <b-card class="mt-2">
                    <portal-target name="OrderAttachmentsView"> </portal-target>
                </b-card>
            </b-col>
        </b-form-row>

        <b-form-group
            v-show="!!orderModel.order_type_id"
            id="input-group-date"
            label="Due Date*:"
            label-for="input-date"
            label-class="font-weight-bold pt-0"
            label-cols="2"
        >
            <b-form-input
                id="input-date"
                v-model="orderModel.date"
                type="date"
                required
                :disabled="!editMode"
            ></b-form-input>
        </b-form-group>

        <b-form-group
            v-show="!!orderModel.order_type_id"
            id="input-group-time"
            label="Due Time*:"
            label-for="input-time"
            label-class="font-weight-bold pt-0"
            label-cols="2"
        >
            <b-form-input
                id="input-time"
                v-model="orderModel.time"
                type="time"
                required
                :disabled="!editMode"
            ></b-form-input>
        </b-form-group>
    </b-form>
</template>
<script>
import order_api from '@/api/order'
import ViewCustomer from '@/views/Customers/ViewCustomer'

import orderHelperMixins from '@/mixins/orderHelperMixins'
import popupMixins from '@/mixins/popupMixins'
import CustomerTypeAhead from '@/components/CustomerTypeAhead.vue'

import permissionsMixins from '@/mixins/permissionsMixins'

import EventBus from '@/exports/event-bus.js'

const scheduledDate = new Date(Date.now() + 24 * 60 * 60 * 1000)
    .toISOString()
    .split('T')[0]
const scheduledTime = '09:30:00'

const model_keys = Object.freeze([
    'id',
    'order_type_id',
    'customer_id',
    'description',
    'driver_id',
    'reference_no',
    'request_category_id',
    'order_template_id',
    'schedule_at',
    'signature',
    'linked_assets',
    'completed',
    'released',
    'delivery_location_section_id',
])

//const L = window.L
export default {
    name: 'orders-viewSummary',
    components: {
        ViewCustomer,
        CustomerTypeAhead,
    },
    data() {
        return {
            itemAddType: 0,
            isCustomerVisible: false,
            orderModel: {},
            category_id: null,
            driverModified: false,
            hasErrors: false,
            defaultDriver: null,
            primary_orders: [],
            primary_order_reference_no: null,
            valueWatchNotCompleted: true,
            isValueSet: false,
        }
    },
    mixins: [orderHelperMixins, popupMixins, permissionsMixins],
    props: ['viewMode'],
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        mapOptions(arr) {
            return arr.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
    },
    computed: {
        isNew() {
            return !(this.order && this.order.id)
        },
        order() {
            return this.$store.state.orders.item
        },
        allowTemplate() {
            return (
                !this.order.completed &&
                (this.isNew || !this.order.order_template_id)
            )
        },
        entities() {
            return this.$store.getters['transactionType/entities']
        },
        entity() {
            if (this.orderModel.order_type_id) {
                const _orderType =
                    this.orderTypes.find(
                        x => x.id === this.orderModel.order_type_id
                    ) || {}
                return (
                    _orderType.transaction_type &&
                    _orderType.transaction_type.entity
                )
            } else {
                return null
            }
        },
        order_type_name() {
            const type = this.orderTypes.find(
                x => x.id === this.orderModel.order_type_id
            )
            return (type && type.name) || ''
        },
        request_category_name() {
            const category = this.categories.find(
                x => x.id === this.orderModel.request_category_id
            )
            return (category && category.name) || ''
        },
        officer_name() {
            const officer = this.officers.find(
                x => x.id === this.orderModel.driver_id
            )
            return (officer && officer.name) || ''
        },

        editMode() {
            return this.isNew || !this.viewMode
        },
        signature_options() {
            return [
                {
                    value: true,
                    text: 'Yes',
                },
                {
                    value: false,
                    text: 'No',
                },
            ]
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },

        officers() {
            const _officers = this.$store.getters['users/sorted_officers']
            console.log('_officers', _officers)
            return _officers
        },

        orderTypes() {
            return this.$store.state.orderType.items
        },
        categories() {
            return this.$store.state.requestCategory.categories
        },
    },

    watch: {
        'orderModel.id': function (id) {
            if (!id) {
                const { orderTypes, categories } = this
                this.setKeyDefault(orderTypes, 'order_type_id')
                this.setKeyDefault(categories, 'request_category_id')
            }
        },
        'orderModel.driver_id': function (id) {
            console.log('check driver update', id)
            console.log('Default Driver check', this.defaultDriver)
            if (this.defaultDriver && id !== this.defaultDriver) {
                this.driverModified = true
                console.log('driver modified check')
            } else {
                console.log('driver is not modified check')
                this.driverModified = false
            }
        },
        orderTypes: {
            handler: function (items) {
                this.setKeyDefault(items, 'order_type_id')
            },
            deep: true,
        },
        categories: {
            handler: function (items) {
                this.setKeyDefault(items, 'request_category_id')
            },
            deep: true,
        },
        order: {
            handler: function () {
                this.$nextTick(() => this.setOrderForm())
            },
            deep: true,
        },
        driverModified: function (driverModified) {
            EventBus.$emit('set-order-model', {
                order: this.orderModel,
                driverModified,
            })
        },
        orderModel: {
            handler: function (order) {
                EventBus.$emit('set-order-model', {
                    order,
                    driverModified: this.driverModified,
                })
            },
            deep: true,
        },
        itemAddType: function (val) {
            console.log('itemaddtype', val)
            if (val == 2) {
                this.$nextTick(() => {
                    EventBus.$emit('trigger-add-item', val)
                })
            }
        },
    },

    created() {
        EventBus.$on('update-assets', linked_assets => {
            this.$set(this.orderModel, 'linked_assets', linked_assets)
        })
    },

    mounted() {
        this.setOrderForm()
    },
    methods: {
        setKeyDefault(items, key) {
            if (items) {
                const defaultType = items.find(x => !!x.is_default)
                if (defaultType) {
                    this.$set(this.orderModel, key, defaultType.id)
                }
            }
        },
        showOrderTemplateModal() {
            this.$bvModal.show('order-template-modal')
        },
        async validateOrderSummary() {
            let {
                entity,
                entities,
                orderModel: { customer, customer_id },
            } = this

            console.log('customer', location)

            if (!(await this.$validator.validate()))
                throw new Error('Incomplete Submission')

            console.log({ entity, entities })

            if (entity == entities.Customer) {
                const { name, location, location_section_id } = customer || {}
                if (!customer_id && !name)
                    throw new Error('Customer Name is Required!')

                if (!location_section_id && location && !location.city)
                    throw new Error('Customer Location City is Required!')
            }
        },
        getModel() {
            return this.orderModel
        },
        setOrderForm() {
            console.log('setOrderForm order', this.order)
            for (var key in this.orderModel) {
                delete this.orderModel[key]
            }
            this.defaultDriver = this.order.driver_id
            for (const key of model_keys) {
                switch (key) {
                    case 'schedule_at': {
                        const { date, time } = this.getScheduleAtParts(
                            this.order.schedule_at
                        )
                        this.$set(
                            this.orderModel,
                            'date',
                            date || scheduledDate
                        )
                        this.$set(
                            this.orderModel,
                            'time',
                            time || scheduledTime
                        )
                        break
                    }
                    case 'linked_assets': {
                        const val = this.order[key]
                        let linked_assets = []
                        if (val) {
                            linked_assets = JSON.parse(val)
                        }
                        this.$set(this.orderModel, key, linked_assets)
                        break
                    }
                    case 'released':
                    case 'completed': {
                        this.$set(this.orderModel, key, this.order[key] || 0)
                        break
                    }
                    default: {
                        this.$set(this.orderModel, key, this.order[key] || null)
                    }
                }
            }
            console.log('setOrderForm orderModel', this.orderModel)
        },

        async setNewCustomerForm() {
            const isChanged = ($this => {
                const {
                    orderModel: { customer_id, customer },
                    isCustomerVisible,
                } = $this
                const { code, name, email, phone, location_section_id } =
                    customer || {}
                return (
                    (isCustomerVisible &&
                        !!(
                            code ||
                            name ||
                            email ||
                            phone ||
                            location_section_id
                        )) ||
                    !!customer_id
                )
            })(this)
            if (!isChanged || (await this.confirmCustomerToggle())) {
                this.isCustomerVisible = !this.isCustomerVisible
                this.orderModel.customer_id = null
            }
        },

        async confirmCustomerToggle() {
            return await this.$bvModal.msgBoxConfirm(
                'This will erase the customer information. Are you sure?'
            )
        },

        setCustomer(customer) {
            console.log('setCustomer', customer)
            this.$set(this.orderModel, 'customer', customer)
        },

        async getLastCustomerOrder(customer_id) {
            const query = ''
            const page = 1
            const filters = { customer_id }
            const result = await order_api.fetch(query, filters, page)
            let orders = result.data.success.data.data
            console.log('first order', orders[0])
            if (orders.length > 0) {
                this.orderModel.driver_id = orders[0].driver_id
            }
        },
    },
}
</script>
<style></style>
